import { createAction, props } from '@ngrx/store';
import { DashboardItem } from '@dashboards/models/dashboard-item';
import { IColumnDefinition } from '@common/models/column-definition';
import { IResizedColumn } from '@common/models/table';
import { IContext } from '@context/models/context';

const name = (s: string) => `[Widget Columns API] ${s}`;
export const apiLoadAvailableColumns = createAction(
  name('Load Available Columns'),
  props<{ widget: DashboardItem }>()
);

export const apiLoadColumnsComplete = createAction(
  name('Load Available Columns Complete'),
  props<{ widget: DashboardItem, columns: IColumnDefinition[] }>()
);

export const apiChangeSelectedColumns = createAction(
  name('Change Selected Columns'),
  props<{ columns: IColumnDefinition[], widget: DashboardItem }>()
);

export const apiChangeSelectedComplete = createAction(
  name('Change Selected Columns Complete'),
  props<{ columns: IColumnDefinition[], widget: DashboardItem }>()
);

export const apiResetColumns = createAction(
  name('Reset Columns'),
  props<{ widget: DashboardItem }>()
);

export const apiResetColumnsComplete = createAction(
  name('Reset Columns Complete'),
  props<{ widget: DashboardItem, columns: IColumnDefinition[] }>()
);

export const apiResizeColumn = createAction(
  name('Resize Columns'),
  props<{ column: IResizedColumn, widget: DashboardItem }>()
);

export const apiResizeColumnComplete = createAction(
  name('Resize Columns Complete'),
  props<{ widget: DashboardItem }>()
);

export const apiReorderColumns = createAction(
  name('Reorder Columns'),
  props<{ widget: DashboardItem, columnFieldNames: Array<string> }>()
);

export const apiReorderColumnsComplete = createAction(
  name('Reorder Columns Complete'),
  props<{ widget: DashboardItem }>()
);
